import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import R from 'ramda'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import VisitAverageAttendanceActions from '../../Data/Redux/VisitAverageAttendanceRedux'
import ClassroomActions from '../../Data/Redux/ClassroomRedux'
import Tool from '../../Components/ReportsComponents/Tool'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import ReportTemplate from './ReportTemplate'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

const COLORS = ['#152940', '#4B3F72', '#904C77', '#119DA4', '#53A2FF']

class CenterVisitAverage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getVisitAverageAttendance, getClassrooms } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'attendance/center-visit-average')
        getClassrooms({'basic':true,'students':false})
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'attendance/center-visit-average')
        getClassrooms({'basic':true,'students':false})
      }
    } else {
      getVisitAverageAttendance()
    }


    if (this.props.user === 'Director') {
      getClassrooms({'basic':true,'students':false})
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const data = []
    const { centerVisitAverage, centers, classrooms, user, centersInfo, activeCenter } = nextProps
    if (centerVisitAverage && centers) {
      if (user === 'Director') {
        Object.keys(centerVisitAverage).map((distribution) => {
          const item = { date: distribution, formatDay: moment(distribution).format('MMM DD') }
          let total = 0
          centerVisitAverage[distribution].map((date) => {
            const newClassroom = classrooms.find(c => c.id === date.classroom_id)
            if (newClassroom) {
              item[newClassroom.name] = parseFloat(date.visit_average)
              total += parseFloat(date.visit_average)
            }
          })
          item['total'] = total
          data.push(item)
        })
      } else {
        if (centersInfo) {
          let centerToShow = null
          let classroomsToRender = null
          if (classrooms && centers) {
            centerToShow = centers.find(c => c.id == activeCenter);
            classroomsToRender = classrooms.filter(cl => cl.center == centerToShow.name)
          }
          if (classroomsToRender) {
            Object.keys(centersInfo).map((distribution) => {
              const item = { date: distribution, formatDay: moment(distribution).format('MMM DD') }
              let total = 0
              centersInfo[distribution].map((date) => {
                const newClassroom = classroomsToRender.find(c => c.id === date.classroom_id)
                if (newClassroom) {
                  item[newClassroom.name] = parseFloat(date.visit_average)
                  total += parseFloat(date.visit_average)
                }
              })
              item['total'] = total
              data.push(item)
            })
          }
        }
        if (!R.isEmpty(centerVisitAverage)) {
          Object.keys(centerVisitAverage).map((distribution) => {
            const item = { date: distribution, formatDay: moment(distribution).format('MMM DD') }
            let total = 0
            centerVisitAverage[distribution].map((date) => {
              const newCenter = centers.find(c => c.id === date.center_id)
              if (newCenter) {
                item[newCenter.abbreviation] = parseFloat(date.visit_average)
                total += parseFloat(date.visit_average)
              }
            })
            item['total'] = total
            data.push(item)
          })
        }
      }
      this.setState({ data })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  getLines = () => {
    const { classrooms, centers, activeCenter , fromCenter} = this.props
    let lines = null
    if (fromCenter) {
      let centerToShow = null
      let classroomsToRender = null
      if (classrooms && centers) {
        centerToShow = centers.find(c => c.id == activeCenter);
        classroomsToRender = classrooms.filter(cl => cl.center == centerToShow.name)
      }
      if (classroomsToRender) {
        lines = classroomsToRender.map((value, index) => {
          return (
            <Line key={index} dataKey={value.name} stackId="a" stroke={this.pickColor(value.name) ? COLORS[index % COLORS.length] : 'gray'} />
          )
        })
      }
    } else if (this.props.user === 'Director') {
      lines = this.props.classrooms.map((value, index) => {
        return (
          <Line key={index} dataKey={value.name} stackId="a" stroke={this.pickColor(value.name) ? COLORS[index % COLORS.length] : 'gray'} />
        )
      })
    } else {
      lines = this.props.centers.map((value, index) => {
        return (
          <Line key={index} dataKey={value.abbreviation} stackId="a" stroke={this.pickColor(value.abbreviation) ? COLORS[index % COLORS.length] : 'gray'} />
        )
      })
    }
    return lines
  }

  pickColor = (name) => {
    let count = 0
    for (let i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i][name] && (this.state.data[i][name] !== 0 && this.state.data[i][name] !== null)) {
        count++
      }
    }
    return count > 0
  }

  filter = ({ currentTarget: { id: abbreviation } }) => {
    const newState = { ...this.state }
    const { centerVisitAverage, centers, classrooms, user } = this.props
    if (user === 'Director') {
      for (let i = 0; i < newState.data.length; i++) {
        if (newState.data[i][abbreviation] && (newState.data[i][abbreviation] !== 0 && newState.data[i][abbreviation] !== null)) {
          newState.data[i][abbreviation] = null
          const { date } = newState.data[i]
          const average = centerVisitAverage[date]
          const newClassroom = classrooms.find(c => c.name === abbreviation)
          const selectedAverage = average.find(avg => avg.classroom_id === newClassroom.id)
          newState.data[i]['total'] -= parseFloat(selectedAverage.visit_average)
        } else if (newState.data[i][abbreviation] === 0 || newState.data[i][abbreviation] === null) {
          const { date } = newState.data[i]
          const average = centerVisitAverage[date]
          const newClassroom = classrooms.find(c => c.name === abbreviation)
          const selectedAverage = average.find(avg => avg.classroom_id === newClassroom.id)
          newState.data[i][abbreviation] = parseFloat(selectedAverage.visit_average)
          newState.data[i]['total'] += parseFloat(selectedAverage.visit_average)
        }
      }
    } else {
      for (let i = 0; i < newState.data.length; i++) {
        if (newState.data[i][abbreviation] && (newState.data[i][abbreviation] !== 0 && newState.data[i][abbreviation] !== null)) {
          newState.data[i][abbreviation] = null
          const { date } = newState.data[i]
          const average = centerVisitAverage[date]
          const newCenter = centers.find(c => c.abbreviation === abbreviation)
          const selectedAverage = average.find(avg => avg.center_id === newCenter.id)
          newState.data[i]['total'] -= parseFloat(selectedAverage.visit_average)
        } else if (newState.data[i][abbreviation] === 0 || newState.data[i][abbreviation] === null) {
          const { date } = newState.data[i]
          const average = centerVisitAverage[date]
          const newCenter = centers.find(c => c.abbreviation === abbreviation)
          const selectedAverage = average.find(avg => avg.center_id === newCenter.id)
          newState.data[i][abbreviation] = parseFloat(selectedAverage.visit_average)
          newState.data[i]['total'] += parseFloat(selectedAverage.visit_average)
        }
      }
    }
    this.setState(newState)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('attendance/center-visit-average', this.props.activeCenter)
    } else {
      this.props.getVisitAverageAttendanceExcel()
    }
  }

  render() {
    const { centerVisitAverage, centers, user, centersInfo, fromCenter } = this.props
    const { width, data } = this.state
    return (
      <ReportTemplate
        title={(user === 'Director' || fromCenter) ? 'Horas promedio Visita Sala' : 'Horas promedio Visita Centro'}
        date={((centerVisitAverage || centersInfo) && data[0]) &&
          { initial: data[0].date, end: data[data.length - 1].date }}
        onClick={this.download}
        loading={!(centers.length > 0)}
      >
        {centers.length > 0 &&
          <LineChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="formatDay" />
            <YAxis />
            <Tooltip content={<Tool withoutCurrency large />} />
            <Legend content={<CustomizedLegend onClick={!fromCenter && this.filter} />} />
            {this.getLines()}
          </LineChart>
        }
      </ReportTemplate>
    )
  }
}


const mapStateToProps = ({ visitAverageAttendance, centerOptions, classrooms, auth, centersInfo }) => ({
  centerVisitAverage: visitAverageAttendance.get.results,
  centers: centerOptions.get.results,
  user: auth.user.role,
  classrooms: classrooms.get.results,
  centersInfo: centersInfo.center_visit_average.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getVisitAverageAttendance: () => dispatch(VisitAverageAttendanceActions.getRequest({}, true)),
  getVisitAverageAttendanceExcel: () => dispatch(VisitAverageAttendanceActions.VisitAverageAttendanceExcelRequest()),
  getClassrooms: (query) => dispatch(ClassroomActions.getRequest(query)),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CenterVisitAverage))



// WEBPACK FOOTER //
// ./src/Containers/Reports/CenterVisitAverage.jsx